<template>
  <footer class="text-center text-sm mt-10 text-dark-400">
    <div class="md:flex md:items-center md:justify-center">
      <div class="inline-flex items-center">
        <a href="https://www.stripe.com" target="_blank" class="flex items-center">
          Stripe
        </a>
      </div>
      <div>
        <span class="mx-1 hidden md:inline">·</span>
        <a href="https://www.beyondbreath.com/en/legal/terms" target="_blank" class=""> Terms </a>
        <span class="mx-1">·</span>
        <a href="https://www.beyondbreath.com/en/legal/privacy" target="_blank" class=""> Privacy </a>
      </div>
    </div>
  </footer>
</template>
